import React from "react";
import { connect } from "react-redux";
import { Route, Switch, withRouter } from "react-router-dom";

import MainLogin from "./MainLogin";
import Login from "./Login";
import Instructor from "./Instructor";
import Student from "./Student";
import { listenAuthorization } from "../firebaseApi";
import { changeAccount } from "../redux";

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

function Router(props) {

  React.useEffect(() => {
    let unsub = listenAuthorization((accountDetails) => {
      props.changeAccount(accountDetails);
      props.history.push("./loading");
    });
    return unsub;
  }, []);

  React.useEffect(() => {
    checkPermission();
  }, [props.account, props.selRole]);

  function checkPermission() {
    switch (props.selRole) {
      case "instructor":
        props.history.push("/instructor/");
        break;
      case "ta":
      props.history.push("/ta/");
        break;
      case "student":
        props.history.push("/student/");
        break;
      default:
        props.history.push("/login/");
    }
  }

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <Switch>
        <Route path="/login/" component={MainLogin} />
        <Route path="/secondary_login/" component={Login} />
        <Route
          path="/instructor/:courseID?/:sessionID?/:pollID?"
        >
          <Instructor key={`${props.account.accountEmail}-${props.selRole}`} />
        </Route>
        <Route
          path="/ta/:courseID?/:sessionID?/:pollID?"
        >
          <Instructor key={`${props.account.accountEmail}-${props.selRole}`} />
        </Route>
        <Route path="/student/:courseID?/:pollID?" component={Student} />
      </Switch>
    </LocalizationProvider>
  );
}

const mapStateToProps = (state) => {
  return { 
    account: state.account,
    selRole: state.selRole,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeAccount: (data) => dispatch(changeAccount(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Router));
